import { useState, useEffect } from 'react';

// Hook to manage page content from admin panel
export const usePageContent = (pageKey, defaultContent) => {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    const loadContent = () => {
      const savedContent = localStorage.getItem('adminPageContent');
      if (savedContent) {
        const pageContent = JSON.parse(savedContent);
        if (pageContent[pageKey]) {
          setContent(prev => ({
            ...prev,
            ...pageContent[pageKey]
          }));
        }
      }
    };

    loadContent();

    const handleContentUpdate = (event) => {
      if (event.detail && event.detail.pageContent && event.detail.pageContent[pageKey]) {
        setContent(prev => ({
          ...prev,
          ...event.detail.pageContent[pageKey]
        }));
      }
    };

    window.addEventListener('contentUpdated', handleContentUpdate);
    
    return () => {
      window.removeEventListener('contentUpdated', handleContentUpdate);
    };
  }, [pageKey]);

  return content;
};

// Hook to manage page meta data (title, description)
export const usePageMeta = (pageKey, defaultMeta) => {
  useEffect(() => {
    const updateMeta = () => {
      const savedContent = localStorage.getItem('adminPageContent');
      if (savedContent) {
        const pageContent = JSON.parse(savedContent);
        if (pageContent[pageKey]) {
          const { title, metaDescription } = pageContent[pageKey];
          
          if (title) {
            document.title = title;
          }
          
          if (metaDescription) {
            let metaDesc = document.querySelector('meta[name="description"]');
            if (!metaDesc) {
              metaDesc = document.createElement('meta');
              metaDesc.setAttribute('name', 'description');
              document.head.appendChild(metaDesc);
            }
            metaDesc.setAttribute('content', metaDescription);
          }
        }
      } else if (defaultMeta) {
        // Set defaults if no saved content
        if (defaultMeta.title) document.title = defaultMeta.title;
        if (defaultMeta.metaDescription) {
          let metaDesc = document.querySelector('meta[name="description"]');
          if (!metaDesc) {
            metaDesc = document.createElement('meta');
            metaDesc.setAttribute('name', 'description');
            document.head.appendChild(metaDesc);
          }
          metaDesc.setAttribute('content', defaultMeta.metaDescription);
        }
      }
    };

    updateMeta();

    const handleContentUpdate = () => updateMeta();
    window.addEventListener('contentUpdated', handleContentUpdate);
    
    return () => {
      window.removeEventListener('contentUpdated', handleContentUpdate);
    };
  }, [pageKey, defaultMeta]);
};

export default { usePageContent, usePageMeta };